import translate from "./translations";

export const getStatus = (status: number) => {
  switch (status) {
    case undefined:
      return "";
    case 1:
      return translate("Inactive_Text", "Inactive TODO");
    case 2:
      return translate("Active_Text", "Active TODO");
    case 3:
      return translate("Locked_Text", "Locked TODO");
    case 4:
      return translate("Blocked_Text", "Blocked TODO");
    case 5:
      return translate("Archived_Text", "Archived TODO");
    default:
      return translate("Inactive_Text", "Inactive TODO");
  }
};

export const getProductType = (type: number) => {
  switch (type) {
    case undefined:
      return "";
    case 1:
      return translate("Closed_Loop_Text", "Closed Loop TODO");
    case 2:
      return translate("Restricted_Loop_Text", "Restricted Loop TODO");
    default:
      return translate("Cross_Pollination_Text", "Cross Pollination TODO");
  }
};
export const getProductUsageType = (type: number) => {
  switch (type) {
    case undefined:
      return "";
    case 1:
      return translate("Single_Use_Text", "Single Use TODO");
    default:
      return translate("Multiple_Use_Text", "Multiple Use TODO");
  }
};
